import { render, staticRenderFns } from "./reclamacoesSideBar.vue?vue&type=template&id=0ae658f3"
import script from "./reclamacoesSideBar.vue?vue&type=script&lang=js"
export * from "./reclamacoesSideBar.vue?vue&type=script&lang=js"
import style0 from "./reclamacoesSideBar.vue?vue&type=style&index=0&id=0ae658f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports